export function filter({ display_name: name }, search) {
  return name.toLowerCase().includes(search.toLowerCase())
}
